import { render, staticRenderFns } from "./BasePDFViewer.vue?vue&type=template&id=0f2b12da&scoped=true&"
import script from "./BasePDFViewer.vue?vue&type=script&lang=js&"
export * from "./BasePDFViewer.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFViewer.vue?vue&type=style&index=0&id=0f2b12da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b12da",
  null
  
)

export default component.exports